import { useEffect } from "react";

/** Injecte un bloc JSON-LD dans le <head> le temps de la page. */
export const useJsonLd = (id, data) => {
  useEffect(() => {
    if (!data) return undefined;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    el.textContent = JSON.stringify(data);
    document.head.appendChild(el);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, [id, data]);
};
